import { FunctionComponent } from 'react'
import { ChecklistDocumentFilter } from '@black-bear-energy/black-bear-energy-common'
import { Box, Tabs, Tab, rucksack } from '@black-bear-energy/rucksack'
import { SearchBar } from '../common/SearchBar'
import { DocumentFilterCounts } from '../helpers/DocumentExchange/DocumentFilterCounts'

export const SearchBarAndFilterTabs: FunctionComponent<
  SearchBarAndFilterTabsProps
> = ({ searchBarLabel, counts, search, setSearch, filter, setFilter }) => {
  const entries = Object.entries(counts) as [
    keyof DocumentFilterCounts,
    number | null
  ][]
  const filterTabs = entries.map(([key, count], ind) => {
    const { label, value } = getTabProps(key, count)
    return (
      <Tab
        label={label}
        key={ind}
        value={value}
        sx={{
          borderRadius: rucksack.shape.borderRadius,
          '&[aria-selected="true"]': {
            background: '#c8e6f2', // palette / primary / _states / focusVisible
            color: rucksack.palette.primary.dark,
          },
        }}
      />
    )
  })

  const handleFilterChange = (
    _event: React.SyntheticEvent,
    newFilter: ChecklistDocumentFilter
  ) => {
    setFilter(newFilter)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: 1.5,
      }}
    >
      <Tabs
        sx={{ width: 'var(--lg, 1200px)' }}
        value={filter}
        onChange={handleFilterChange}
        variant="fullWidth"
        slotProps={{
          indicator: { sx: { display: 'none' } },
        }}
      >
        {filterTabs}
      </Tabs>
      <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
        <SearchBar
          label={searchBarLabel}
          search={search}
          setSearch={setSearch}
        />
      </Box>
    </Box>
  )
}

function getTabProps(
  key: keyof DocumentFilterCounts,
  count: number | null
): { label: string; value: ChecklistDocumentFilter } {
  const countSuffix = count === null ? '' : ` (${count})`
  switch (key) {
    case 'all':
      return {
        label: `All${countSuffix}`,
        value: ChecklistDocumentFilter.All,
      }
    case 'requiredMissing':
      return {
        label: `Still Needed${countSuffix}`,
        value: ChecklistDocumentFilter.RequiredMissing,
      }
    case 'reviewMissing':
      return {
        label: `Pending Review${countSuffix}`,
        value: ChecklistDocumentFilter.ReviewMissing,
      }
    case 'verified':
      return {
        label: `Verified${countSuffix}`,
        value: ChecklistDocumentFilter.Verified,
      }
  }
}

export interface SearchBarAndFilterTabsProps {
  searchBarLabel: string
  counts: DocumentFilterCounts
  search: string
  setSearch: (search: string) => void
  filter: ChecklistDocumentFilter
  setFilter: (filter: ChecklistDocumentFilter) => void
}
